import PropTypes from 'prop-types';
import React from 'react';
import announcementApi from 'api/announcement';
import {injectIntl, intlShape} from 'react-intl';

class Announcement extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      announcements: []
    };
  }

  componentDidMount() {
    announcementApi.getAnnouncementDealer().then((response) => {
      this.setState({ announcements: response });
    })
    .catch(error => {
      console.error(error);
    });
  };

  renderImage = (announcements) => { 
    const {locale} = this.props.intl;

    if (announcements) {
      return (
        <div>
          {
            locale === 'en-US' && announcements.english && announcements.english.ContentURL ?
            <div className='announcement-wrapper'><img className='img-responsive center-block' src={announcements.english.ContentURL} alt='Announcement Image' /></div>
            : locale === 'fr-CA' && announcements.french && announcements.french.ContentURL ?
            <div className='announcement-wrapper'><img className='img-responsive center-block' src={announcements.french.ContentURL} alt='Announcement Image' /></div>
            : null
          } 
        </div>
      );
    }
  };

  render() {
    return (
      <div>
        {this.renderImage(this.state.announcements)}
      </div>
    );
  }
}

export default injectIntl(Announcement);
